import React, { useState } from "react";
import "../App.css";
import {
  SafProductHeader,
  SafLogo,
  SafProductHeaderItem,
  SafIcon,
  SafSrOnly,
  SafButton
} from "@saffron/core-components/react";
const Header = ({userData}) => {
  const username = userData?.firstName ;

  
  return (
    <div className="Component-demo">
      <SafProductHeader
          tasks-aria-label="Product"
          global-aria-label="Global"
          data-testid="default"
        >
         <SafLogo slot="logo" appearance="1-color-orange"></SafLogo> 
          <div slot="global">
            <SafProductHeaderItem>
              <SafButton appearance="secondary">
                {username}
              </SafButton>
            </SafProductHeaderItem>
          </div>
        </SafProductHeader>
    </div>
  );
};
export default Header;
